<template>
	<div id="div-with-loading">
		<div class="indented-section mx-auto client-sso-form">
			<div class="vx-row flex flex-wrap justify-between">
				<div class="radix-logo mx-auto">
					<!-- <img src="../../assets/images/logo/falcon-x-radix.svg" alt="Radix Logo" /> -->
					<img class="ml-2" src="../../assets/images/logo/radix-logo-black.svg" alt="Radix Logo" height="25"/>
				</div>

				<!-- TODO: Add it back when the logos for all partners are added to system -->
				<!-- <div class="partner-logo my-auto">
					<img src="../../assets/images/partner-logos/GoDaddy-Black.png" width="120" height="30" alt="Partner Logo" />
				</div> -->
			</div>

			<div class="vx-row justify-center mt-2" v-if="isAccessCodeSent">
				<p style="font-size: 11px; text-align: center;">
					Please enter the access code that you've received in your inbox:
				</p>
			</div>
			
			<div class="vx-row mt-4 justify-center" v-if="isAccessCodeSent">
				<div class="vx-col">
					<label class="vs-input--label inline-flex pb-2">Access Code</label>
					<vs-input
						class="w-full" 
						type="password"
						name="Access Code" 
						v-model="accessCode"
						v-validate="'required'"
						data-vv-validate-on="change"
						:danger="errors.has('Access Code')"
						:danger-text="'Required field'" />
				</div>
			</div>

			<div class="vx-row mt-4 justify-center" v-if="isAccessCodeSent">
				<vs-button id="button-with-loading" color="primary" type="filled" class="custom-btn mx-auto w-50" icon-after @click="verifyAccessCode">Submit</vs-button>
			</div>

			<div class="vx-row mt-8 justify-center" v-else>
				<vs-button id="button-with-loading" color="dark" type="filled" class="custom-btn mx-auto w-50" icon-after @click="getAccessCode">Get OTP</vs-button>
			</div>
		</div>

		<custom-prompt :activePrompt.sync="customPrompt['activePrompt']" :title="customPrompt['title']" :buttonText="customPrompt['buttonText']" :type="customPrompt['type']" :color="customPrompt['color']" :classList="customPrompt['classList']">
			<div class="con-content" slot="content">
				<p v-if="customPromptMessage">{{ customPromptMessage }}</p>
				<p v-else-if="customPromptError">{{ customPromptError }}</p>
			</div>
		</custom-prompt>
	</div>
</template>

<script>
import CustomPrompt from "@/components/CustomPrompt.vue";

export default {
	name: 'PartnerSignOn',
	components: {
		CustomPrompt
	},
	data() {
		return {
			period: '',
			emailAddress: '',
			accessCode: '',
			isAccessCodeSent: false,
			// Custom Dialog props
			customPrompt: {
				activePrompt: false,
				type: '',
				title: '',
				buttonText: '',
				acceptText: '',
				color: '',
				classList: '',
			},
			customPromptMessage: null,
			customPromptError: null,
			// Source
			redirect: null,
			partnerName: null,
		}
	},
	created() {
		// NOTE: Redirect to current cycle page if partner is already logged in and attempts to land here
		if(localStorage.getItem('isPartnerLoggedIn')) {
			this.$router.push(`/partner/current-cycle/${localStorage.getItem('loggedInPartnerName')}`);
		}
	},
	computed: {
		source() {
			if(this.$route.query.redirect) {
				return this.$route.query.redirect;
			} else {
				if(this.$route.query.partnerName) {
					return `/partner/current-cycle/${this.$route.query.partnerName}`
				}
			}
		}
	},
	methods: {
		async getAccessCode() {
			await this.$vs.loading();
			this.customPromptMessage = null;
			this.customPromptError = null;

			await this.$axiosSecure.post('/rebates/client/token', { url_value: this.$route.query.partnerName })
			.then((response) => {
				this.customPromptMessage = response.data.message;

				if(response.data.type == 'Success') {
					this.isAccessCodeSent = true;

					this.customPrompt['activePrompt'] = true;
					this.customPrompt['title'] = 'Code Sent!';
					this.customPrompt['acceptText'] = 'Okay';
					this.customPrompt['color'] = 'primary'
					this.isEmailVerified = true;
				}
			})
			.catch((error) => {
				this.customPromptError = error.response.data.message;

				this.customPrompt['activePrompt'] = true;
				this.customPrompt['type'] = 'error';
				this.customPrompt['title'] = 'Error';
				this.customPrompt['acceptText'] = 'Okay';
				this.customPrompt['color'] = 'danger';
				this.customPrompt['classList'] = 'danger-prompt';
			})

			await this.$vs.loading.close();
		},
		async verifyAccessCode() {
			await this.$vs.loading();
			this.customPromptMessage = null;
			this.customPromptError = null;

			await this.$axiosSecure.post('/rebates/client/token-verification', { token : this.accessCode, url_value: this.$route.query.partnerName })
			.then(response => {
				this.customPromptMessage = response.data.message;
				let validAccessCode = response.data.type == 'Success';

				if(validAccessCode) {
					localStorage.setItem('isPartnerLoggedIn', true);
					localStorage.setItem('clientRebateStatus', response.data.data.status);
					localStorage.setItem('loggedInPartnerId', response.data.data.new_reseller_id);
					localStorage.setItem('clientToken', this.accessCode);

					this.$store.dispatch('setClientRebateStatus', response.data.data.status);
					this.$store.dispatch('setClientToken', this.accessCode);
					this.$store.dispatch('setClientAMName', response.data.data.am_name);
					this.$store.dispatch('setClientAMEmail', response.data.data.am_email);

					setTimeout(() => {
						this.$router.push(this.source);
					}, 100)
				} else {
					this.customPrompt['activePrompt'] = true;
					this.customPrompt['type'] = 'error';
					this.customPrompt['title'] = 'Invalid Access Code!';
					this.customPrompt['acceptText'] = 'Okay';
					this.customPrompt['color'] = 'danger';
					this.customPrompt['classList'] = 'danger-prompt';
				}
			})
			.catch(error => {
				this.customPromptError = error.response.data.message;

				this.customPrompt['activePrompt'] = true;
				this.customPrompt['type'] = 'error';
				this.customPrompt['title'] = 'Error';
				this.customPrompt['acceptText'] = 'Okay';
				this.customPrompt['color'] = 'danger';
				this.customPrompt['classList'] = 'danger-prompt';
			})

			await this.$vs.loading.close();
		}
	},
};
</script>